import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../../../services/common';
import { Subject, takeUntil } from 'rxjs';
import { SalesService } from '../../sales.service';
import { SumByKeyPipe } from '../../../../shared/pipes/sumbykeypipe';

@Component({
  selector: 'app-unit-category-sale-report',
  templateUrl: './unit-category-sale-report.component.html',
  styleUrl: './unit-category-sale-report.component.scss'
})
export class UnitCategorySaleReportComponent implements OnInit {

  private destroy$ = new Subject<void>();
  saleList: any;
  saleReportRequest: any
  totalUnitsSum: any = 0;
  totalUnitBookedSum: any = 0
  totalUnitAlottedSum: any = 0
  totalAmountSoldUnit: any = 0
  totalAmountReceived: any = 0
  totalBalancedAmountSum: any = 0

  constructor(public commonService: CommonService, private saleService: SalesService) { }

  ngOnInit(): void {
    this.saleReportRequest = {
      "ReportFrequency": 'daily',
    }

    this.getSaleReportDate();
  }

  getSaleReportDate() {
    this.commonService.selectedProjects$
      .pipe(takeUntil(this.destroy$)).subscribe((selectedProject: any) => {

        this.resetAllTotals();

        //project ids has tp go in array as for admin view we may need report for all in single view
        this.saleReportRequest.projectId = [selectedProject?.id]

        this.saleService.getUnitCategoryWiseSale(this.saleReportRequest).subscribe(res => {
          if (res != null && res?.result.length > 0) {
            this.saleList = res?.result.map((cat: any) => {
              this.totalUnitsSum = this.totalUnitsSum + ((cat?.totalUnits != null && cat?.totalUnits != undefined) ? cat?.totalUnits : 0);
              this.totalUnitBookedSum = this.totalUnitBookedSum + ((cat?.unitsBooked != null && cat?.unitsBooked != undefined) ? cat?.unitsBooked : 0);
              this.totalUnitAlottedSum = this.totalUnitAlottedSum + ((cat?.unitsAllotted != null && cat?.unitsAllotted != undefined) ? cat?.unitsAllotted : 0);
              this.totalAmountSoldUnit = this.totalAmountSoldUnit + ((cat?.amountOfSoldUnits != null && cat?.amountOfSoldUnits != undefined) ? cat?.amountOfSoldUnits : 0);
              this.totalAmountReceived = this.totalAmountReceived + ((cat?.amountReceived != null && cat?.amountReceived != undefined) ? cat?.amountReceived : 0);
              this.totalBalancedAmountSum = this.totalBalancedAmountSum + ((cat?.balancedAmount != null && cat?.balancedAmount != undefined) ? cat?.balancedAmount : 0);

              cat.balancedAmount = ((cat?.amountOfSoldUnits != null ? cat?.amountOfSoldUnits : 0) -
                (cat?.amountReceived != null ? cat?.amountReceived : 0))?.toLocaleString('en-IN');


              cat.amountOfSoldUnits = cat?.amountOfSoldUnits.toLocaleString('en-IN')
              cat.amountReceived = cat?.amountReceived?.toLocaleString('en-IN');
              return cat;
            })

            this.totalBalancedAmountSum = this.totalAmountSoldUnit - this.totalAmountReceived
            this.totalBalancedAmountSum = this.totalBalancedAmountSum?.toLocaleString('en-IN');

            this.totalAmountSoldUnit = this.totalAmountSoldUnit?.toLocaleString('en-IN');
            this.totalAmountReceived = this.totalAmountReceived?.toLocaleString('en-IN');

          }
        })
      });
  }

  resetAllTotals() {
    this.totalUnitsSum = 0
    this.totalUnitBookedSum = 0
    this.totalUnitAlottedSum = 0
    this.totalAmountSoldUnit = 0
    this.totalAmountReceived = 0
    this.totalBalancedAmountSum = 0
  }

  ngOnDestroy(): void {
    // Signal completion to clean up subscriptions
    this.destroy$.next();
    this.destroy$.complete();
  }
}
